import { bl_inv_opdg_element_by_item_hdr_RowClass } from '../../dbschema';
import { BaseContainerModel } from '../base-container.model';

export class InventoryOpdgElementByItemHdrModel extends BaseContainerModel {
  bl_inv_opdg_element_by_item_hdr: bl_inv_opdg_element_by_item_hdr_RowClass = new bl_inv_opdg_element_by_item_hdr_RowClass();
}
